module.exports = __webpack_public_path__ + "img/Jump Casting8.a0cce9ce.jpg";